import { DashboardListModal } from '@shared-types/components/dashboardListModal';
import create, { SetState } from 'zustand';




export interface DashboardListModalStore extends DashboardListModal {
  closeDashboardListModal: () => void;
  openDashboardListModal: () => void;
};


const dashboardListModalDefaultData = {
  isDashboardListModalVisible: false
};

const dashboardListModalActions = (set: SetState<DashboardListModalStore>) => ({
  closeDashboardListModal: () =>
    set((state) => {
      state.isDashboardListModalVisible = false;
    }),
  openDashboardListModal: () =>
    set((state) => {
      state.isDashboardListModalVisible = true;
    }),
})

export const useDashboardListModalStore = create<DashboardListModalStore>(
  (set: SetState<DashboardListModalStore>) => ({
    ...dashboardListModalDefaultData,
    ...dashboardListModalActions(set)
  })
)